module.exports = __webpack_public_path__ + "static/img/he2.b080775.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he2.png
// module id = HsW6
// module chunks = 1